
// Option lists for the integration screens.
//
// These are constants rather than lookup tables on purpose. Both are contracts with code, not
// per-client data: a protocol only works if esb-interface has a switch case that builds a route
// for it, so a row added to a table would produce an integration that silently never starts.
// The filter lists in CustomFilter are the opposite - alarm priorities and message sources are
// genuinely per-site, and those read from the database.

/**
 * Integration protocols, matching the switch in
 * esb-interface DynamicRouteBuilder.createRoute - API, HL7, MQTT, SNMP, TCP, UDP.
 *
 * SNMP was missing from the selector while sources.js already had a branch rendering its
 * parameters, so that branch was unreachable and an SNMP integration could not be created from
 * the console at all despite the backend supporting it.
 *
 * Keep this in step with that switch. Adding an entry here without a case there gives an
 * integration that saves and never runs.
 */
export const Protocols = Object.freeze([
    { value: 'API', label: 'API' },
    { value: 'HL7', label: 'HL7' },
    { value: 'MQTT', label: 'MQTT' },
    { value: 'SNMP', label: 'SNMP' },
    { value: 'TCP', label: 'TCP' },
    { value: 'UDP', label: 'UDP' },
]);

/**
 * Message formats for a source - MessageSource.Format.
 *
 * Note this is NOT the protocol list, despite the overlap in names: it describes how a
 * message's payload is encoded, and the field has no consumer in the Java services at all -
 * only the console reads it, to decide whether to show the API section on the routing screen.
 * The two lists are separate because they answer different questions.
 */
export const MessageFormats = Object.freeze([
    { value: 'JSON', label: 'JSON' },
    { value: 'TAP', label: 'TAP' },
    { value: 'UDP', label: 'UDP' },
    { value: 'TCP', label: 'TCP' },
    { value: 'API', label: 'API' },
]);
